<template>
  <div class="c-header">
    <div class="c-header__content">
      <h1>
        Serwis Dealera BMW Inchcape{{
          getDealers && lead.dealer_id != "" && getDealers.find((e) => e.id == lead.dealer_id)
            ? " " + getDealers.find((e) => e.id == lead.dealer_id).city
            : ""
        }}.
      </h1>
      <a href="/">
        <img src="@/assets/logo.png" alt="Serwis Dealera BMW Inchcape Wrocław" class="c-header__logo" />
      </a>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import lead from "../mixins/lead.js";

export default {
  mixins: [lead],
  computed: {
    ...mapGetters({
      getDealers: "definitions/getDealers",
    }),
  },
};
</script>
<style lang="scss">
.c-header {
  width: 100%;
  min-height: 68px;
  display: flex;
  justify-content: flex-end;
  padding-bottom: 2.5rem;
  box-shadow: $bottomShadow;

  &__content {
    background-color: $brightgray;
    width: 100%;
    min-height: 66px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 4rem;
    padding-left: 11vw;
  }

  &__logo {
    max-height: 60px;
    height: auto;
  }
}
</style>
